export type DeskPlanScheduleStatus =
  | "scheduled"
  | "active"
  | "disabled"
  | "unavailable"
  | "stale"
  | "invalid"
  | "dependency_unavailable";

export interface LockoutPolicy {
  lockoutEnabled: boolean;
  autoLockFromDeskPlan: boolean;
  autoReleaseMinutes: number;
}

export interface DeskPlanSchedule {
  status: DeskPlanScheduleStatus;
  timezone: "America/New_York";
  detail: string;
  planDate: string | null;
  planGeneratedAt: string | null;
  windowStartAt: string | null;
  windowEndAt: string | null;
  releaseAt: string | null;
  eventName: string | null;
}

export interface LockoutState {
  locked: boolean;
  until: string | null;
  remaining: number | null;
  autoReleaseAt?: string | null;
  scheduledBy?: string | null;
  reason?: string | null;
  policy: LockoutPolicy | null;
  policyResolved: boolean;
  schedule?: DeskPlanSchedule | null;
  commandOk?: boolean;
  error?: string | null;
}

export function emptyLockoutState(error: string | null = null): LockoutState {
  return {
    locked: false,
    until: null,
    remaining: null,
    autoReleaseAt: null,
    scheduledBy: null,
    reason: null,
    policy: null,
    policyResolved: false,
    schedule: null,
    commandOk: false,
    error,
  };
}
